export interface IDisposable {
  dispose(): void
}

export const MILLISECOND = 1000
export const SECOND = 1
